import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/vuex/app';
import auth from '@/vuex/auth';
import accounts from '@/vuex/accounts';
import paths from '@/vuex/paths';
import players from '@/vuex/players';
import missions from '@/vuex/missions';
import infosheets from '@/vuex/infosheets';
import stats from '@/vuex/stats';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    accounts,
    paths,
    missions,
    players,
    infosheets,
    stats,
  },
  strict: debug,
});
